import { automaticApi } from '@/settings/api';
import environment from '@/settings/environment';
import { clearString } from '@/utils/functions';
import { AxiosResponse } from 'axios';
import { Action } from 'redux-saga';
import { call, CallEffect, PutEffect } from 'redux-saga/effects';

export interface Fetch {
  document: string;
  pin: string;
  callback: (success: boolean, data?: string) => void;
}

export interface ValidatePinForgotAction {
  type: string;
  payload: Fetch;
}

const uri = `/login-app/${environment.api?.loginVersion ?? "v1"}/recuperarSenha/validapin`;

export default function* validatePinForgot({
    payload,
}: ValidatePinForgotAction): Generator<
    CallEffect<unknown> | PutEffect<Action>,
    void,
    AxiosResponse
> {
  try {
    const body = {
      cpf: clearString(payload.document),
      pin: payload.pin,
    };
    const response: {
      data: {
        hsacc: string;
        status: {
          codigoRetorno: number;
        };
      };
    } = yield call(automaticApi.post, uri, body);

    if (response?.data?.status?.codigoRetorno === 0) {
      yield call(payload.callback, true, response?.data?.hsacc);
    } else {
      yield call(payload.callback, false);
    }
  } catch (error) {
    yield call(payload.callback, false);
  }
}